let Env = {
  DUTY_CAST_EXTENSION_DEBUG_MODE: undefined,
  DUTY_CAST_BUILD_APP_VERSION: undefined,
  DUTY_CAST_EXTENSION_API: undefined,
  DUTY_CAST_EXTENSION_SEARCH_API: undefined,
  DUTY_CAST_EXTENSION_SEARCH_INDEX: undefined,
  DUTY_CAST_EXTENSION_AUTOCOMPLETE_INDEX: undefined,
  DUTY_CAST_EXTENSION_FAQ_INDEX: undefined,
  DUTY_CAST_APPLE_CLIEND_ID: undefined,
  DUTY_CAST_APPLE_REDIRECT_URL: undefined,
  DUTY_CAST_FACEBOOK_APP_ID: undefined,
  DUTY_CAST_GOOGLE_CLIENT_ID: undefined,
  DUTY_CAST_GOOGLE_ANALYTIC_KEY: undefined,
  DUTY_CAST_GOOGLE_TAG_KEY: undefined,
  DUTY_CAST_GOOGLE_ADS_KEY: undefined,
  DUTY_CAST_TRACKING_URL: undefined,
  DUTY_CAST_IMGFOE_URL: undefined,
  DUTY_CAST_BUILD_TIMESTAMP: undefined,
  DUTY_CAST_STRIPE_API_KEY: undefined,
  DUTY_CAST_EXTENSION_INSTALL_CHROME: undefined,
  DUTY_CAST_EXTENSION_INSTALL_EDGE: undefined,
  DUTY_CAST_EXTENSION_INSTALL_SAFARI: undefined,
  DUTY_CAST_EXTENSION_INSTALL_CHPLAY: undefined,
  DUTY_CAST_EXTENSION_STORE_REDIRECT_TIME: undefined,
  DUTY_CAST_EXTENSION_FIREBASE_API_KEY: undefined,
  DUTY_CAST_EXTENSION_FIREBASE_AUTH_DOMAIN: undefined,
  DUTY_CAST_EXTENSION_FIREBASE_DATABASE_URL: undefined,
  DUTY_CAST_EXTENSION_FIREBASE_PROJECT_ID: undefined,
  DUTY_CAST_EXTENSION_FIREBASE_STORAGE_BUCKET: undefined,
  DUTY_CAST_EXTENSION_FIREBASE_MESSAGING_SENDER_ID: undefined,
  DUTY_CAST_EXTENSION_FIREBASE_REF: undefined,
  DUTY_CAST_EXTENSION_API_OFFICES: undefined,
  DUTY_CAST_EXTENSION_PUBLIC_TRACK_URL: undefined,
  DUTY_CAST_EXTENSION_API_IN_THE_PRESS: undefined,
  DUTY_CAST_EXTENSION_CONFIRM_PHONE_RESEND_DELAY: undefined,
  DUTY_CAST_EXTENSION_API_BANNER_ON_TOP: undefined,
  DUTY_CAST_EXTENSION_API_BANNER_SLIDER: undefined,
  DUTY_CAST_EXTENSION_API_TRUSTED_PARTNERS: undefined,
  DUTY_CAST_EXTENSION_APPOTA_JWT_TTL: undefined,
  DUTY_CAST_EXTENSION_METABASE_URL: undefined,
  DUTY_CAST_EXTENSION_API_PRODUCT_ADS: undefined,
  DUTY_CAST_EXTENSION_API_TESTIMONIAL: undefined,
  DUTY_CAST_EXTENSION_API_LIST_COUNTRY_STORES: undefined,
  DUTY_CAST_EXTENSION_API_SALE_DIALOG: undefined,
  DUTY_CAST_EXTENSION_API_BANNER_CATEGORY: undefined,
  DUTY_CAST_EXTENSION_AUTH_PROVIDER: undefined,
  DUTY_CAST_GOOGLE_SCRIPT_WAITTING_TIME: undefined,
  DUTY_CAST_EXTENSION_HIDE_SEARCH: undefined,
  DUTY_CAST_MAX_ESTIMATE_PRICE_TIME: undefined,
  DUTY_CAST_ESTIMATE_PRICE_DELAY: undefined,
  DUTY_CAST_SEARCH_TRANSLATE_TIMEOUT: undefined,
  DUTY_CAST_SEARCH_TRANSLATE_DELAY: undefined,
  DUTY_CAST_PRICE_TAGS_UNIT: undefined,
  DUTY_CAST_PRICE_TAGS_PERIOD: undefined,
  DUTY_CAST_TRANSLATE_SELECTOR: undefined,
  DUTY_CAST_ACCEPT_PAYMENT_METHOD: undefined,
  DUTY_CAST_ACCEPT_MERCHANT_FILTER: undefined,
}

Env = window.env || process.env;

// devLog(Env);

export default Env;